/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DoctorExtraSpecialtyStatus = {
  type: 'Enum',
} as const;
